import { deserialize } from 'cerialize'
import { ReceivingFileModel, ShortDataModel } from 'Models'
import { AttachmentProduct } from 'Pages/orders'
import { ProductSlugs } from 'Constants/ProductSlugs'
import { ClientType } from 'Pages/orders_design'

export class ProductRecommendationModel {
	@deserialize public attachment: AttachmentProduct = null
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public slug: ProductSlugs
	@deserialize public product_group: ShortDataModel
	@deserialize public recommendations: ShortDataModel[]
	@deserialize public online_option: boolean
	@deserialize public reserve_account: boolean
	@deserialize public is_free_service: boolean
	@deserialize public description: string
	@deserialize public knowledge_url = ''
	@deserialize public block_product_group_ids?: number[]
	@deserialize public description_updated_at: string
	@deserialize public client_type: ClientType
	@deserialize public customer_logo?: ReceivingFileModel
	@deserialize public available_lk_neo: boolean
}
